var _g, _g2, _g3, _g4, _tspan, _tspan2, _tspan3, _tspan4, _tspan5, _tspan6, _tspan7, _tspan8, _tspan9, _tspan10, _tspan11, _tspan12, _tspan13, _tspan14, _tspan15, _tspan16, _tspan17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSunset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 708,
    height: 708,
    viewBox: "0 0 708 708",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "base"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.989 145.274V176.251H108.218C103.719 176.251 86.932 182.135 86.932 198.748V231.629H103.199V241.32H55.0895L33.4572 262.953V307.428H54.5702V327.503H30.8613V391.188H57.3394V414.022H34.4541V469.519H142.589V448.012H162.892V502.004H202.747L206.733 498.019L213.35 504.636L205.755 512.231V533.587L219.441 547.273H239.143V545.469H325.019V687.142H423.679V631.044L510.232 544.491V500.801H488.5V458.84H574.977V350.706H595.431V362.587L605.207 372.363H672.283V284.381H650.476V264.078H672.283V197.904H627.766V200.46H607.312V192.489H603.552L591.446 180.382V176.096H583.099V155.943H607.312V134.737C607.312 128.872 604.304 111.275 585.054 111.275H462.481L456.24 105.034V26.1513H395.555C391.344 26.1513 368.032 22.2409 360.663 19.0826C353.294 15.9243 346.676 13.6685 336.449 11.8638C328.268 10.42 322.212 10.46 320.206 10.6605L311.634 17.8795H296.143C290.879 18.832 279.87 20.8273 277.945 21.1882C275.539 21.6394 273.584 23.1434 271.929 26.7529C270.275 30.3624 267.117 34.4231 265.462 35.7767C264.713 36.3896 262.021 38.8529 259.062 41.5605C255.487 44.8323 251.521 48.461 250.122 49.6131C245.323 52.7735 243.335 59.0602 242.061 63.0881C241.698 64.2354 241.394 65.1995 241.098 65.8558C239.745 68.8638 238.391 73.9772 238.391 75.782V145.274H259.989ZM303.205 101.941H282.949V197.808H303.554V187.156H411.47V101.941H391.389V123.419H303.205V101.941ZM238.333 199.38V242.511H330.359V262.592H281.639V300.66H283.211V306.073H217.379L196.337 285.031V199.38H238.333ZM136.966 241.027V231.597H173.636V342.482H164.032V241.027H136.966ZM77.6377 285.957V327.688H119.517V285.957H77.6377ZM104.719 391.329H96.3598V414.092H229.467V475.437L225.095 479.81L231.782 486.497L238.47 479.81V414.092H325.536V393.708H303.866L281.682 371.523V329.083H250.559V372.423H139.572L134.942 364.064L118.48 372.423L123.239 381.555L104.719 391.329ZM389.817 334.449V348.943H378.991V415.473H389.817V430.316H369.561V334.449H389.817ZM282.877 500.745V458.983H415.431L434.499 437.789V415.591H455.004V544.827L423.338 576.493H380.447V583.642H369.536V500.745H282.877ZM530.403 414.066V372.361H510.2V374.959H465.465V220.694H369.5V242.511H364.161V262.592H369.5V290.683L384.941 306.124H423.471V372.217H412.793V392.42H454.642V389.967H510.2V414.066H530.403ZM439.905 156.032H543.787V176.126H541.175V219.527H530.526V262.728H510.131V246.653H499.381V237.008H510.131V198.53L487.727 176.126H439.905V156.032ZM508.217 307.297C505.993 307.297 499.321 310.756 499.321 315.822V319.776C499.321 322.247 503.522 327.683 508.217 327.683H627.854V239.749H607.532V307.297H508.217Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "objects"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_301_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 10,
    width: 643,
    height: 678
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M259.989 145.274V176.251H108.218C103.719 176.251 86.932 182.135 86.932 198.748V231.629H103.199V241.32H55.0895L33.4572 262.953V307.428H54.5702V327.503H30.8613V391.188H57.3394V414.022H34.4541V469.519H142.589V448.012H162.892V502.004H202.747L206.733 498.019L213.35 504.636L205.755 512.231V533.587L219.441 547.273H239.143V545.469H325.019V687.142H423.679V631.044L510.232 544.491V500.801H488.5V458.84H574.977V350.706H595.431V362.587L605.207 372.363H672.283V284.381H650.476V264.078H672.283V197.904H627.766V200.46H607.312V192.489H603.552L591.446 180.382V176.096H583.099V155.943H607.312V134.737C607.312 128.872 604.304 111.275 585.054 111.275H462.481L456.24 105.034V26.1513H395.555C391.344 26.1513 368.032 22.2409 360.663 19.0826C353.294 15.9243 346.676 13.6685 336.449 11.8638C328.268 10.42 322.212 10.46 320.206 10.6605L311.634 17.8795H296.143C290.879 18.832 279.87 20.8273 277.945 21.1882C275.539 21.6394 273.584 23.1434 271.929 26.7529C270.275 30.3624 267.117 34.4231 265.462 35.7767C264.713 36.3896 262.021 38.8529 259.062 41.5605C255.487 44.8323 251.521 48.461 250.122 49.6131C245.323 52.7735 243.335 59.0602 242.061 63.0881C241.698 64.2354 241.394 65.1995 241.098 65.8558C239.745 68.8638 238.391 73.9772 238.391 75.782V145.274H259.989ZM303.205 101.941H282.949V197.808H303.554V187.156H411.47V101.941H391.389V123.419H303.205V101.941ZM238.333 199.38V242.511H330.359V262.592H281.639V300.66H283.211V306.073H217.379L196.337 285.031V199.38H238.333ZM136.966 241.027V231.597H173.636V342.482H164.032V241.027H136.966ZM77.6377 285.957V327.688H119.517V285.957H77.6377ZM104.719 391.329H96.3598V414.092H229.467V475.437L225.095 479.81L231.782 486.497L238.47 479.81V414.092H325.536V393.708H303.866L281.682 371.523V329.083H250.559V372.423H139.572L134.942 364.064L118.48 372.423L123.239 381.555L104.719 391.329ZM389.817 334.449V348.943H378.991V415.473H389.817V430.316H369.561V334.449H389.817ZM282.877 500.745V458.983H415.431L434.499 437.789V415.591H455.004V544.827L423.338 576.493H380.447V583.642H369.536V500.745H282.877ZM530.403 414.066V372.361H510.2V374.959H465.465V220.694H369.5V242.511H364.161V262.592H369.5V290.683L384.941 306.124H423.471V372.217H412.793V392.42H454.642V389.967H510.2V414.066H530.403ZM439.905 156.032H543.787V176.126H541.175V219.527H530.526V262.728H510.131V246.653H499.381V237.008H510.131V198.53L487.727 176.126H439.905V156.032ZM508.217 307.297C505.993 307.297 499.321 310.756 499.321 315.822V319.776C499.321 322.247 503.522 327.683 508.217 327.683H627.854V239.749H607.532V307.297H508.217Z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_301_2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "objects_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M150 209H139V232H150V209Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M294 197H283V220H294V197Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M358 197H336V199H358V197Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M325 263H281V274H325V263Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M165 240H142V253H165V240Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M131 306H119V318H131V306Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M304 447H282V459H304V447Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M326 534H315V546H326V534Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M332 681H325V687H332V681Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M417 681H424V687H417V681Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M342 682H332V687H342V682Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M407 682H417V687H407V682Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M363 682H352V687H363V682Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M386 682H397V687H386V682Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M352 683H342V687H352V683Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M397 683H407V687H397V683Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M299 442H288V447H299V442Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M369 398H358V409H369V398Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M466 209H455V220H466V209Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M542 139H531V155H542V139Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M337.194 328.566L330.703 322.075L314 338.778L320.491 345.269L337.194 328.566Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M526 414H515V425H526V414Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M526 296H515V307H526V296Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M673 284H661V296H673V284Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M673 294H666V301H673V294Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M586 182.5V174.5H608V197.5H601L586 182.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M563 215H530V225H563V215Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M590.913 272.421L583.135 264.643L564 283.778L571.778 291.556L590.913 272.421Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M507.556 327.778L499.778 320L490.732 329.046L498.51 336.824L507.556 327.778Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M464.824 110.778L457.046 103L448 112.046L455.778 119.824L464.824 110.778Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M137 306H131V312H137V306Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M38 374H31V379H38V374Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M43 379H31V392H43V379Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M89 441H65V452H89V441Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M192 435C192 433.343 193.343 432 195 432H200C201.657 432 203 433.343 203 435V459C203 460.657 201.657 462 200 462H195C193.343 462 192 460.657 192 459V435Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M207 328C207 326.343 208.343 325 210 325H215C216.657 325 218 326.343 218 328V350C218 351.657 216.657 353 215 353H210C208.343 353 207 351.657 207 350V328Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M156 215H150V221H156V215Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M161 220H150V232H161V220Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M136 306.5H164.5",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M368 305.5H396.5",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M465 285H477V241.5H500",
    className: "line"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M302 197H412",
    className: "line"
  }))))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "areas"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M607 304.235V222.766C607 221.238 605.762 220 604.234 220H533.766C532.238 220 531 221.238 531 222.766V304.235C531 305.762 532.238 307 533.766 307H604.234C605.762 307 607 305.762 607 304.235Z",
    strokeWidth: 1.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M139.234 263H57.7656C56.2382 263 55 264.238 55 265.766V347.234C55 348.762 56.2382 350 57.7656 350H139.234C140.762 350 142 348.762 142 347.234V265.766C142 264.238 140.762 263 139.234 263Z",
    strokeWidth: 1.6
  }))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "text"
  }, /*#__PURE__*/React.createElement("text", {
    id: "A Lobby",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Plus Jakarta Sans",
    fontSize: 8.5,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan || (_tspan = /*#__PURE__*/React.createElement("tspan", {
    x: 508,
    y: 444.968
  }, "A Lobby"))), /*#__PURE__*/React.createElement("text", {
    id: "Mid Courtyard",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Plus Jakarta Sans",
    fontSize: 8.5,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan2 || (_tspan2 = /*#__PURE__*/React.createElement("tspan", {
    x: 300,
    y: 329.968
  }, "Mid Courtyard"))), /*#__PURE__*/React.createElement("text", {
    id: "B Market",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Plus Jakarta Sans",
    fontSize: 8.5,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan3 || (_tspan3 = /*#__PURE__*/React.createElement("tspan", {
    x: 197,
    y: 341.968
  }, "B Market"))), /*#__PURE__*/React.createElement("text", {
    id: "B Boba",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Plus Jakarta Sans",
    fontSize: 8.5,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan4 || (_tspan4 = /*#__PURE__*/React.createElement("tspan", {
    x: 129,
    y: 195.968
  }, "B Boba"))), /*#__PURE__*/React.createElement("text", {
    id: "Mid Top",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Plus Jakarta Sans",
    fontSize: 8.5,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan5 || (_tspan5 = /*#__PURE__*/React.createElement("tspan", {
    x: 318,
    y: 221.968
  }, "Mid Top"))), /*#__PURE__*/React.createElement("text", {
    id: "A Link",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Plus Jakarta Sans",
    fontSize: 8.5,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan6 || (_tspan6 = /*#__PURE__*/React.createElement("tspan", {
    x: 455,
    y: 195.968
  }, "A Link"))), /*#__PURE__*/React.createElement("text", {
    id: "A Alley",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Plus Jakarta Sans",
    fontSize: 8.5,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan7 || (_tspan7 = /*#__PURE__*/React.createElement("tspan", {
    x: 525,
    y: 129.968
  }, "A Alley"))), /*#__PURE__*/React.createElement("text", {
    id: "B Main",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Plus Jakarta Sans",
    fontSize: 8.5,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan8 || (_tspan8 = /*#__PURE__*/React.createElement("tspan", {
    x: 132,
    y: 431.968
  }, "B Main"))), /*#__PURE__*/React.createElement("text", {
    id: "B Lobby",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Plus Jakarta Sans",
    fontSize: 8.5,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan9 || (_tspan9 = /*#__PURE__*/React.createElement("tspan", {
    x: 238,
    y: 518.968
  }, "B Lobby"))), /*#__PURE__*/React.createElement("text", {
    id: "Mid Bottom",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Plus Jakarta Sans",
    fontSize: 8.5,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan10 || (_tspan10 = /*#__PURE__*/React.createElement("tspan", {
    x: 266,
    y: 431.968
  }, "Mid Bottom"))), /*#__PURE__*/React.createElement("text", {
    id: "A Main",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Plus Jakarta Sans",
    fontSize: 8.5,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan11 || (_tspan11 = /*#__PURE__*/React.createElement("tspan", {
    x: 511,
    y: 354.968
  }, "A Main"))), /*#__PURE__*/React.createElement("text", {
    id: "Mid Tiles",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Plus Jakarta Sans",
    fontSize: 8.5,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan12 || (_tspan12 = /*#__PURE__*/React.createElement("tspan", {
    x: 378,
    y: 384.968
  }, "Mid Tiles"))), /*#__PURE__*/React.createElement("text", {
    id: "A Elbow",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Plus Jakarta Sans",
    fontSize: 8.5,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan13 || (_tspan13 = /*#__PURE__*/React.createElement("tspan", {
    x: 622,
    y: 276.968
  }, "A Elbow")))), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg",
    id: "areaLabels"
  }, /*#__PURE__*/React.createElement("text", {
    id: "B",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Plus Jakarta Sans",
    fontSize: 14,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan14 || (_tspan14 = /*#__PURE__*/React.createElement("tspan", {
    x: 541,
    y: 296.712
  }, "A"))), /*#__PURE__*/React.createElement("text", {
    id: "A",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Plus Jakarta Sans",
    fontSize: 14,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan15 || (_tspan15 = /*#__PURE__*/React.createElement("tspan", {
    x: 61,
    y: 281.712
  }, "B"))), /*#__PURE__*/React.createElement("text", {
    id: "defender",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Plus Jakarta Sans",
    fontSize: 14,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan16 || (_tspan16 = /*#__PURE__*/React.createElement("tspan", {
    x: 324,
    y: 66.712
  }, "Defenders"))), /*#__PURE__*/React.createElement("text", {
    id: "attacker",
    xmlSpace: "preserve",
    style: {
      whiteSpace: "pre"
    },
    fontFamily: "Plus Jakarta Sans",
    fontSize: 14,
    fontWeight: 800,
    letterSpacing: "0em"
  }, _tspan17 || (_tspan17 = /*#__PURE__*/React.createElement("tspan", {
    x: 348,
    y: 632.712
  }, "Attackers")))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunset);
export default __webpack_public_path__ + "static/media/sunset.b093296a.svg";
export { ForwardRef as ReactComponent };